<main
    animate.enter="slide-x"
    class="safe-top safe-bottom absolute z-[9999] top-0 right-0 min-w-[360px] h-screen bg-white flex flex-col overflow-y-scroll"
>
    @if (user(); as user) {
        <section class="flex flex-col gap-4 min-h-[800px] h-full">
            <div class="flex justify-end w-full px-4 py-3">
                <app-icon
                    (click)="close()"
                    class="text-gray-500 cursor-pointer !size-7"
                    name="material-symbols:close-rounded"
                />
            </div>

            <div class="flex flex-col gap-4 px-6">
                <div class="flex items-center justify-between">
                    <div class="flex flex-col gap-2">
                        <p class="font-semibold text-gray-800">
                            {{ user.name }} 선생님
                        </p>
                        <p class="text-xs text-gray-400">
                            {{ user.auths[0].email }}
                        </p>
                    </div>
                    <button class="flex items-center" routerLink="/my-page">
                        <app-icon
                            name="material-symbols:arrow-forward-ios"
                            class="text-gray-300 cursor-pointer"
                            size="sm"
                        />
                    </button>
                </div>
                <div class="border border-gray-200 rounded-2xl">
                    <div
                        class="bg-[#D75E63] flex items-center justify-between rounded-t-xl px-4 py-2"
                    >
                        <p class="text-sm text-white">센터</p>
                        <img
                            src="/my-page/profile-icon.svg"
                            class="w-8 h-5"
                            alt="프로필 로고"
                        />
                    </div>
                    <div
                        class="flex justify-between items-center w-full p-4 gap-3"
                    >
                        <div class="flex items-center gap-2">
                            <app-center-role-badge />
                            <div class="text-gray-800">
                                {{ center()?.name }}
                            </div>
                        </div>
                        <button
                            (click)="close()"
                            routerLink="/center"
                            class="flex items-center gap-1"
                        >
                            <p class="text-xs text-gray-400">센터관리</p>
                            <app-icon
                                class="text-gray-300"
                                name="material-symbols:arrow-forward-ios"
                                size="xs"
                            />
                        </button>
                    </div>
                </div>

                <div class="flex items-center gap-2.5">
                    @for (menu of menus(); track $index) {
                        <button
                            (click)="close()"
                            [routerLink]="menu.link"
                            class="flex flex-col items-center justify-center flex-1 h-full gap-1 cursor-pointer min-h-14"
                        >
                            <app-icon
                                [name]="menu.icon"
                                class="text-gray-500"
                                routerLinkActive="text-primary"
                            />
                            <p
                                class="text-xs font-semibold text-center text-gray-500"
                                routerLinkActive="text-primary"
                            >
                                {{ menu.title }}
                            </p>
                        </button>
                    }
                </div>

                <div class="border-b border-gray-100"></div>

                <!-- 일정 -->
                <div
                    class="flex flex-col gap-4 p-4 border border-gray-100 rounded-2xl"
                >
                    <div class="flex items-center justify-between">
                        <p class="font-semibold text-gray-800">오늘 일정</p>
                        <button routerLink="/schedule">
                            <app-icon
                                name="material-symbols:arrow-forward-ios"
                                class="text-gray-200"
                                size="sm"
                            />
                        </button>
                    </div>
                    <div class="flex flex-col gap-3.5">
                        @for (item of schedules(); track $index) {
                            <div class="flex flex-col gap-3">
                                @if (item.allDay) {
                                    <p
                                        class="text-gray-500 text-xs font-medium"
                                    >
                                        종일
                                    </p>
                                } @else {
                                    <p
                                        class="text-gray-500 text-xs font-medium"
                                    >
                                        {{ item.startDate | date: "HH:mm" }} ~
                                        {{ item.endDate | date: "HH:mm" }}
                                    </p>
                                }
                                <div class="flex gap-1 items-center">
                                    <div
                                        class="px-1 py-0.5 text-xs rounded text-white font-normal"
                                        [style.background]="item.color"
                                    >
                                        {{
                                            eventType[
                                                item.metadata?.type ||
                                                    "PERSONAL"
                                            ]
                                        }}
                                    </div>
                                    <p
                                        class="text-gray-800 text-sm font-medium"
                                    >
                                        {{ item.title }}
                                    </p>
                                </div>
                            </div>
                            @if (!$last) {
                                <div class="w-full h-px bg-gray-100"></div>
                            }
                        } @empty {
                            <p class="text-gray-400 text-sm">
                                오늘 일정이 없습니다.
                            </p>
                        }
                    </div>
                </div>
            </div>
            <div class="flex w-full px-6 p-4 h-full items-end">
                <div (click)="logout()" class="flex gap-2 items-center">
                    <app-icon
                        name="solar:logout-2-bold-duotone"
                        class="text-gray-500"
                    />
                    <p class="text-gray-500 text-sm">로그아웃</p>
                </div>
            </div>
        </section>
    }
</main>
